module.exports = __webpack_public_path__ + "static/media/20210409_192901_805_IMG_0064.c32b33f5.jpg";